import { useEffect } from "react";

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `JCI Bangladesh - ${title}` : "JCI Bangladesh";
    return () => { document.title = "JCI Bangladesh"; };
  }, [title]);
}
